import React from "react";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

import Button from "../../atoms/button/button";
import { normalizeTwoWords, formatImageAlt } from "../../../shared/utils/stringUtilities";

import "./bookActivityClub.scss";

interface BookActivityClubProps {
  contentful_id: string;
  tipoComponente: string;
  titulo: string;
  tituloBoton: string;
  redireccionBoton: string | null;
  descripcion: any ;
  imagenPrincipal: {
    title: string;
    file: {
      url: string;
      fileName: string;
    };
    fluid: any;
  };
  tituloGeneral: string;
  autoresArticulo: Array<any>;
  referenciaTabsContenido: Array<{
    titulo: string;
    nombreTab: string;
    like: number;
    imagenLibro: {
      title: string;
      file: {
        url: string;
        fileName: string;
      };
      fluid: any;
    };
  }> | null;
  gtmClass: string;
}

const BookActivityClub = (props: BookActivityClubProps) => {
  const {
    tituloGeneral,
    descripcion,
    imagenPrincipal,
    tituloBoton,
    redireccionBoton,
    gtmClass,
  } = props;

  return (
    <article className="m-book-activity-club">
      <div className="m-book-activity-club__image">
        <img src={imagenPrincipal.file.url} alt={formatImageAlt(imagenPrincipal.title)} />
      </div>
      <div className="m-book-activity-club__texts">
        <h3 className="m-book-activity-club__texts__title">{tituloGeneral}</h3>
        {documentToReactComponents(descripcion.json)}
        {tituloBoton && (
          <Button
            type={redireccionBoton ? "link" : "button"}
            classname="secondary"
            text={tituloBoton}
            isDisabled={false}
            gtmMark={`gtm${gtmClass}${normalizeTwoWords(
              tituloGeneral
            )}${normalizeTwoWords(tituloBoton)}`}
          />
        )}
      </div>
    </article>
  );
};

export default BookActivityClub;